var React = require('react');

function ArrowFillDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M23.9355,2.2549 C23.8475,2.0979 23.6815,1.9999 23.5005,1.9999 L0.5005,1.9999 C0.3195,1.9999 0.1535,2.0979 0.0645,2.2549 C-0.0235,2.4119 -0.0205,2.6049 0.0735,2.7589 L11.5735,21.7589 C11.6635,21.9079 11.8265,21.9999 12.0005,21.9999 C12.1755,21.9999 12.3375,21.9079 12.4275,21.7589 L23.9275,2.7589 C24.0215,2.6049 24.0255,2.4119 23.9355,2.2549","id":"path-1"}));
}

ArrowFillDown.defaultProps = {"viewBox":"0 0 24 24","version":"1.1"};

module.exports = ArrowFillDown;

ArrowFillDown.default = ArrowFillDown;
